/* eslint-disable react-hooks/exhaustive-deps */
import {MapView} from '../MapView'
import {useContext, useEffect, useMemo, useState} from 'react'
import {DataContext} from '../../context/DataContext'
import {HeaderPerformance} from '../Common/HeaderPerformance'
import {formatNumber} from '../../../explorer/components/common'
import {FilterContext} from '../../context/FilterContext'
import {Tipologia} from '../Types'
import {MaisInfoEmpreendimentos} from '../MaisInfoEmpreendimentos'
import {SelectIncorporadoras} from '../../../explorer/components/Menu/FiltroPrincipal/components/SelectIncorporadoras'
import {Modal} from 'react-bootstrap'

type Props = {
  label?: string
}
type PropMenu = {
  show: boolean
  id: number
}

type FaixaRenda = {
  faixa_renda: string
  total_dom: number
  id_faixa: string
}
type EstudoDemandaRow = {
  rendaMediaDomiciliar: string
  faixaPrecoImovel: string
  domicilios: number | string
  estimativaNovosDomicilios: string
  unidadesLancadas: number | string
  estoque: {value: string; color: string}
  mesesAbsorcao: number
  dorm1: {value: string; color: string}
  dorm2: {value: string; color: string}
  dorm3: {value: string; color: string}
  dorm4: {value: string; color: string}
}

const FAIXAS = [
  ['Faixa 1', 0, 2850, 'faixa_1'],
  ['Faixa 2', 2850, 4700, 'faixa_2'],
  ['Faixa 3', 4700, 8600, 'faixa_3'],
  ['Faixa 4', 8600, 12000, 'faixa_4'],
  ['Média Alta Renda', 12000, 20000, 'media_alta_renda'],
  ['Alta Renda', 20000, 30000, 'alta_renda'],
  ['Altíssima Renda', 30000, 0, 'altissima_renda'],
]

const VSO_IDEAL = [
  {vso: 0, min: 0, max: 0},
  {vso: 30, min: 4, max: 5},
  {vso: 42, min: 9, max: 10},
  {vso: 48, min: 13, max: 14},
  {vso: 54, min: 17, max: 19},
  {vso: 60, min: 22, max: 24},
  {vso: 62, min: 26, max: 29},
  {vso: 64, min: 30, max: 34},
  {vso: 66, min: 35, max: 39},
  {vso: 68, min: 39, max: 43},
  {vso: 70, min: 44, max: 48},
  {vso: 72, min: 48, max: 53},
  {vso: 73, min: 52, max: 58},
  {vso: 74, min: 54, max: 60},
  {vso: 75, min: 56, max: 62},
  {vso: 77, min: 59, max: 65},
  {vso: 78, min: 61, max: 67},
  {vso: 79, min: 63, max: 69},
  {vso: 80, min: 65, max: 72},
  {vso: 81, min: 67, max: 74},
  {vso: 82, min: 69, max: 76},
  {vso: 84, min: 71, max: 79},
  {vso: 85, min: 73, max: 81},
  {vso: 86, min: 75, max: 83},
  {vso: 87, min: 78, max: 86},
  {vso: 88, min: 80, max: 88},
  {vso: 89, min: 82, max: 90},
  {vso: 91, min: 84, max: 93},
  {vso: 92, min: 86, max: 95},
  {vso: 93, min: 88, max: 97},
  {vso: 94, min: 90, max: 100},
  {vso: 95, min: 91, max: 100},
  {vso: 96, min: 92, max: 100},
  {vso: 97, min: 93, max: 100},
  {vso: 98, min: 93, max: 100},
  {vso: 99, min: 94, max: 100},
  {vso: 100, min: 95, max: 100},
]
export function AnaliseConcorrencia({label}: Props) {
  const {
    data,
    setData,
    removeItemTipologia,
    addItemTipologia,
    segmentacao,
    cacheResult,
    setCacheResult,
    comparaveis,
  } = useContext(DataContext)
  const {endereco, geometriaSelecionada, filter} = useContext(FilterContext)
  // const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
  const [dataComputados, setDataComputados] = useState([])
  const [faixasRendaDomTotal, setFaixaRendaDomTotal] = useState<FaixaRenda[]>([])
  const [dataNaoComputados, setDataNaoComputados] = useState([])
  const [showProdutosModal, setShowProdutosModal] = useState(false)
  const [searchNome, setSearchNome] = useState('')
  const [searchIncorporadora, setSearchIncorporadora] = useState('')
  const selectedProdutos = useMemo(
    () => dataComputados.filter((item) => item.destaque),
    [dataComputados]
  )
  // const [filterText, setFilterText] = useState<PropFilter>({
  //   empreendimento: null,
  //   incorporadora: null,
  // })

  useEffect(() => {
    if (cacheResult.sociodemografico) {
      const faixaRendaDomTotal = cacheResult.sociodemografico.filter(
        (item) => item.servico === 'dom-total-faixa-renda-v2'
      )[0]
      setFaixaRendaDomTotal(faixaRendaDomTotal?.resultado?.itens || [])
    }
  }, [cacheResult.sociodemografico])

  const [show, setShow] = useState<PropMenu>({
    show: false,
    id: null,
  })
  const layersList = [] //getLayers(['view_ibge_explorer_renda_mensal_domiciliar'], json)
  const dataTable = []
  const dataTableNaoComputados = []
  const filteredProdutos = useMemo(() => {
    const nome = searchNome.trim().toLowerCase()
    const incorporadora = searchIncorporadora.trim().toLowerCase()
    return dataComputados.filter((item) => {
      const nomeMatch =
        nome === '' ||
        String(item.nome || '')
          .toLowerCase()
          .includes(nome)
      const incorporadoraMatch =
        incorporadora === '' ||
        String(item.incorporadora || '')
          .toLowerCase()
          .includes(incorporadora)
      return nomeMatch && incorporadoraMatch
    })
  }, [dataComputados, searchNome, searchIncorporadora])

  const toggleProdutoSelecionado = (item) => {
    setData((prev) => {
      if (!Array.isArray(prev)) {
        return prev
      }
      let changed = false
      const next = prev.map((empreendimento) => {
        let itemChanged = false
        const tipologias = empreendimento.tipologias?.map((tipologia) => {
          if (tipologia.id_tipologia !== item.id) {
            return tipologia
          }
          itemChanged = true
          return {...tipologia, comparar: !tipologia.comparar}
        })
        if (itemChanged) {
          changed = true
          return {...empreendimento, tipologias}
        }
        return empreendimento
      })
      return changed ? next : prev
    })
  }

  useEffect(() => {
    const comparaveisSet = new Set(comparaveis)
    setData((prev) => {
      if (!Array.isArray(prev)) {
        return prev
      }
      let changed = false
      const next = prev.map((item) => {
        let itemChanged = false
        const tipologias = item.tipologias?.map((tipologia) => {
          const comparar = comparaveisSet.size > 0 && comparaveisSet.has(tipologia.id_tipologia)
          if (tipologia.comparar !== comparar) {
            itemChanged = true
          }
          return {...tipologia, comparar}
        })
        if (itemChanged) {
          changed = true
          return {...item, tipologias}
        }
        return item
      })
      return changed ? next : prev
    })
  }, [comparaveis, setData])
  useEffect(() => {
    if (!data) {
      return
    }
    // eslint-disable-next-line array-callback-return
    data.map((item) => {
      // eslint-disable-next-line array-callback-return
      item.tipologias.map((itemTipologia: Tipologia) => {
        if (itemTipologia.computed) {
          dataTable.push({
            id: itemTipologia.id_tipologia,
            id_empreendimento: item.id_empreendimento,
            id_empreendimento_orulo: item.id_empreendimento_orulo,
            nome: item.nome,
            incorporadora: item.nome_incorporador,
            endereco: item.endereco,
            quartos: itemTipologia.bedrooms,
            data_lancamento: item.data_lancamento,
            area_privativa: itemTipologia.private_area,
            total_unidades: itemTipologia.total_units,
            vso: itemTipologia.vendas_perc_tip,
            estoque: itemTipologia.stock,
            vagas: itemTipologia.parking,
            preco_m2: itemTipologia.original_price / itemTipologia.private_area,
            preco_total: itemTipologia.original_price,
            bairro: item.bairro,
            distancia: item.distancia,
            tipo: itemTipologia.type,
            affordable_program: item.affordable_program === 1 ? 'Sim' : 'Não',
            destaque: itemTipologia.comparar === true,
          })
        }
      })

      setDataComputados(dataTable)
      // setDataNaoComputados(dataTableNaoComputados)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  let {unidadeLancadas, estoque, mesesAbsorcao, vsoIdealTipologia, vsoFinal, vsoIdeal} =
    useMemo(() => {
      const unidadeLancadas = Array(7).fill(0, 0, 7)
      const estoque = Array(7).fill(0, 0, 7)
      const estoqueTipologia = Array.from({length: 7}, () => [])
      const mesesAbsorcao = Array(7).fill(0, 0, 7)
      const totalUnidadesTipologias = Array.from({length: 7}, () => [])
      const vsoIdealTipologia = Array.from({length: 7}, () => [])

      if (data && filter.segmentacaoPreco !== null) {
        // eslint-disable-next-line array-callback-return
        data.map((item) => {
          // eslint-disable-next-line array-callback-return
          item.tipologias.map((itemTipologias) => {
            let preco = itemTipologias.preco_lancamento || itemTipologias.original_price
            if (itemTipologias.computed && preco > 0) {
              const totalUnits = Number(itemTipologias.total_units) || 0
              const stockValue = Number(itemTipologias.stock) || 0
              segmentacao.preco[filter.segmentacaoPreco].forEach((faixas, i) => {
                if (i === 6) {
                  if (preco >= faixas[0]) {
                    const vsoIdealValue = VSO_IDEAL[item.fase_projeto_ideal]?.vso ?? 0
                    const bedroomIndex = Number(itemTipologias.bedrooms) || 0
                    unidadeLancadas[i] = unidadeLancadas[i] + totalUnits
                    estoque[i] = estoque[i] + stockValue

                    if (!Number.isFinite(estoqueTipologia[i][bedroomIndex])) {
                      estoqueTipologia[i][bedroomIndex] = 0
                    }
                    estoqueTipologia[i][bedroomIndex] =
                      estoqueTipologia[i][bedroomIndex] + stockValue

                    if (!Number.isFinite(totalUnidadesTipologias[i][bedroomIndex])) {
                      totalUnidadesTipologias[i][bedroomIndex] = 0
                    }
                    totalUnidadesTipologias[i][bedroomIndex] =
                      totalUnidadesTipologias[i][bedroomIndex] + totalUnits

                    if (!Number.isFinite(vsoIdealTipologia[i][bedroomIndex])) {
                      vsoIdealTipologia[i][bedroomIndex] = 0
                    }
                    vsoIdealTipologia[i][bedroomIndex] += Math.floor(
                      (vsoIdealValue / 100) * totalUnits
                    )
                  }
                } else if (preco >= faixas[0] && preco < faixas[1]) {
                  const vsoIdealValue = VSO_IDEAL[item.fase_projeto_ideal]?.vso ?? 0
                  const bedroomIndex = Number(itemTipologias.bedrooms) || 0
                  unidadeLancadas[i] = unidadeLancadas[i] + totalUnits
                  estoque[i] = estoque[i] + stockValue

                  if (!Number.isFinite(estoqueTipologia[i][bedroomIndex])) {
                    estoqueTipologia[i][bedroomIndex] = 0
                  }
                  estoqueTipologia[i][bedroomIndex] = estoqueTipologia[i][bedroomIndex] + stockValue

                  if (!Number.isFinite(totalUnidadesTipologias[i][bedroomIndex])) {
                    totalUnidadesTipologias[i][bedroomIndex] = 0
                  }
                  totalUnidadesTipologias[i][bedroomIndex] =
                    totalUnidadesTipologias[i][bedroomIndex] + totalUnits

                  if (!Number.isFinite(vsoIdealTipologia[i][bedroomIndex])) {
                    vsoIdealTipologia[i][bedroomIndex] = 0
                  }
                  vsoIdealTipologia[i][bedroomIndex] += Math.floor(
                    (vsoIdealValue / 100) * totalUnits
                  )
                }
              })
            }
          })
        })
      }

      // const vsoFinal = Array.from({length: 7}, () => [])
      // const vsoIdeal = Array.from({length: 7}, () => [])
      // vsoIdealTipologia.map((item, index) => {
      //   item.map((value, bedroomIndex) => {
      //     if (totalUnidadesTipologias[index][bedroomIndex] > 0) {
      //       let vso = Math.round(
      //         ((totalUnidadesTipologias[index][bedroomIndex] -
      //           estoqueTipologia[index][bedroomIndex]) /
      //           totalUnidadesTipologias[index][bedroomIndex]) *
      //           100
      //       )
      //       vsoFinal[index][bedroomIndex] = vso
      //       vsoIdeal[index][bedroomIndex] = Math.round(
      //         (value / totalUnidadesTipologias[index][bedroomIndex]) * 100
      //       )
      //     } else {
      //       vsoFinal[index][bedroomIndex] = 0
      //       vsoIdeal[index][bedroomIndex] = 0
      //     }
      //   })
      // })
      const vsoFinal = Array.from({length: 7}, () => [])
      const vsoIdeal = Array.from({length: 7}, () => [])
      vsoIdealTipologia.map((item, index) => {
        item.map((value, bedroomIndex) => {
          if (totalUnidadesTipologias[index][bedroomIndex] > 0) {
            let vso = Math.round(
              ((totalUnidadesTipologias[index][bedroomIndex] -
                estoqueTipologia[index][bedroomIndex]) /
                totalUnidadesTipologias[index][bedroomIndex]) *
                100
            )
            vsoFinal[index][bedroomIndex] = vso
            vsoIdeal[index][bedroomIndex] = Math.round(
              (value / totalUnidadesTipologias[index][bedroomIndex]) * 100
            )
          } else {
            vsoFinal[index][bedroomIndex] = 0
            vsoIdeal[index][bedroomIndex] = 0
          }
        })
      })

      return {unidadeLancadas, estoque, mesesAbsorcao, vsoIdealTipologia, vsoFinal, vsoIdeal}
    }, [data, filter.segmentacaoPreco, segmentacao.preco])

  const faixas = FAIXAS
  function getDomTotalPorFaixaRenda(id_faixa: string) {
    const result = faixasRendaDomTotal.filter((item) => {
      return item.id_faixa === id_faixa
    })

    if (result.length > 0) {
      return result[0].total_dom
    } else {
      return 0
    }
  }

  if (!data) {
    return <>Carregando...</>
  }

  if (!faixasRendaDomTotal) {
    return <>Carregando...</>
  }

  function onchangeFilter(e: {nome?: string}[] | string[]) {
    const selecionadas = Array.isArray(e) ? e : []
    const nomesSelecionados = selecionadas
      .map((item) => (typeof item === 'string' ? item : item?.nome))
      .filter(Boolean)

    setData((prev) =>
      prev.map((item) => ({
        ...item,
        destaque:
          nomesSelecionados.length > 0 && nomesSelecionados.includes(item.nome_incorporador),
      }))
    )
  }

  return (
    <>
      <div className=' d-flex flex-column justify-content-start p-10'>
        <HeaderPerformance titulo={'Análise Concorrência'}></HeaderPerformance>
        <div className='content pt-5'>
          <div className='row'>
            <div className='col-12'>
              <div className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'>
                <div className='map-painel d-flex w-100'>
                  <div className='mapa col-5'>
                    <MapView
                      data={data}
                      layer={[layersList]}
                      zoom={14}
                      height='500px'
                      center={{lat: endereco.latitude, lng: endereco.longitude}}
                      geometria={geometriaSelecionada}
                    ></MapView>
                  </div>
                  <div className='mapa col-7'>
                    <div className='row'>
                      {/* <div className='col-12 p-15 d-flex align-items-center'>
                        <div className='col-2'>Destacar:</div>
                        <div className='col-10'>
                          <SelectIncorporadoras
                            onChange={(e) => {
                              onchangeFilter(e)
                              // onChangeFiltro('incorporador', e, 'update', 'select')
                            }}
                            returnFull={true}
                            itensSelected={filter?.incorporadora || null}
                          ></SelectIncorporadoras>
                        </div>
                      </div> */}
                      <div className='col-12 px-15 pt-10'>
                        <button
                          className='btn btn-sm btn-secondary'
                          onClick={() => setShowProdutosModal(true)}
                        >
                          Ver produtos ({dataComputados.length})
                        </button>
                      </div>
                      <div className='col-12 px-15'>
                        <table className='table table-comporaveis table-striped table-hover mt-5'>
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Incorporadora</th>
                              <th>Tipologia</th>
                              <th className='text-center'>Área Útil</th>
                              <th className='text-center'>Unidades Lancadas</th>
                              <th className='text-center'>Unidades Vendidas</th>
                              <th className='text-center'>Estoque</th>
                              <th className='text-right'>Preço m2</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedProdutos.map((item, index) => (
                              <tr
                                key={item.id || index}
                                style={{
                                  backgroundColor: item.destaque ? '#FFF3CD' : undefined,
                                }}
                              >
                                <td>{item.nome}</td>
                                <td>{item.incorporadora}</td>
                                <td className='text-center'>{item.quartos}</td>
                                <td className='text-center'>{item.area_privativa}</td>
                                <td className='text-center'>{item.total_unidades}</td>
                                <td className='text-center'>
                                  {item.total_unidades - item.estoque}
                                </td>
                                <td className='text-center'>{item.estoque}</td>
                                <td className='text-right'>
                                  {formatNumber(item.preco_m2, 'currency_inteiro')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showProdutosModal} onHide={() => setShowProdutosModal(false)} size='xl' centered>
        <Modal.Header closeButton>
          <Modal.Title>Produtos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row mb-4'>
            <div className='col-6'>
              <label className='form-label'>Buscar nome</label>
              <input
                type='text'
                className='form-control'
                value={searchNome}
                onChange={(event) => setSearchNome(event.target.value)}
                placeholder='Nome do produto'
              />
            </div>
            <div className='col-6'>
              <label className='form-label'>Buscar incorporadora</label>
              <input
                type='text'
                className='form-control'
                value={searchIncorporadora}
                onChange={(event) => setSearchIncorporadora(event.target.value)}
                placeholder='Nome da incorporadora'
              />
            </div>
          </div>
          <div className='table-produtos table-responsive'>
            <table className='table'>
              <thead>
                <tr>
                  <th></th>
                  <th>Nome</th>
                  <th>Incorporadora</th>
                  <th>Tipologia</th>
                  <th>Area Util</th>
                  <th>Unidades Lancadas</th>
                  <th>Unidades Vendidas</th>
                  <th>Estoque</th>
                  <th>Preco m2</th>
                </tr>
              </thead>
              <tbody>
                {filteredProdutos.map((item, index) => (
                  <tr
                    key={item.id || index}
                    style={{
                      backgroundColor: item.destaque ? '#FFF3CD' : undefined,
                    }}
                  >
                    <td>
                      <input
                        type='checkbox'
                        checked={selectedProdutos.some((produto) => produto.id === item.id)}
                        onChange={() => toggleProdutoSelecionado(item)}
                      />
                    </td>
                    <td>{item.nome}</td>
                    <td>{item.incorporadora}</td>
                    <td>{item.quartos}</td>
                    <td>{item.area_privativa}m²</td>
                    <td>{item.total_unidades}</td>
                    <td>{item.total_unidades - item.estoque}</td>
                    <td>{item.estoque}</td>
                    <td>{formatNumber(item.preco_m2, 'currency_inteiro')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
      <MaisInfoEmpreendimentos
        setShow={setShow}
        show={show}
        height={'calc(100vh)'}
      ></MaisInfoEmpreendimentos>
    </>
  )
}
